export default "__VITE_ASSET__0Qy7HwvV__"